export default "__VITE_ASSET__BGMmGdOf__"